import { Circle, CircleMarker, MapContainer, TileLayer, Tooltip } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { useContent } from "../context/ContentContext";

export const WorkAreaMap = () => {
  const { workArea } = useContent();
  return (
  <div
    data-testid="work-area-map"
    className="relative z-0 h-[320px] w-full overflow-hidden border border-[#DDD9D0] sm:h-[420px]"
  >
    <MapContainer
      center={workArea.center}
      zoom={workArea.zoom}
      scrollWheelZoom={false}
      className="h-full w-full"
      attributionControl={false}
    >
      <TileLayer url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <Circle
        center={workArea.center}
        radius={workArea.radiusKm * 1000}
        pathOptions={{ color: "#111111", weight: 1.5, fillColor: "#E6D8B8", fillOpacity: 0.25, dashArray: "6 6" }}
      />
      {workArea.places.map((p) => (
        <CircleMarker
          key={p.name}
          center={p.coords}
          radius={p.home ? 9 : 5}
          pathOptions={{
            color: "#111111",
            weight: p.home ? 3 : 1.5,
            fillColor: p.home ? "#E6D8B8" : "#111111",
            fillOpacity: 1,
          }}
        >
          <Tooltip direction="top" offset={[0, -6]} permanent={p.home} className="dt-tooltip">
            {p.name}
          </Tooltip>
        </CircleMarker>
      ))}
    </MapContainer>
    <p className="absolute bottom-0 right-0 z-[400] bg-white/85 px-2 py-0.5 text-[10px] text-[#8E8D8A]">
      © OpenStreetMap-bijdragers
    </p>
  </div>
);
};
